'use strict';

define('vb/action/builtin/returnAction',[
  'vb/action/action',
],
(Action) => {
  /** @typedef {import('vb/action/action').Outcome} Outcome */

  /**
   * Represents an action that returns a predefined outcome with a payload.
   *
   * @extends Action
   * @category Action
   */
  class ReturnAction extends Action {
    /**
     * Performs the action by returning a new outcome based on the provided parameters.
     *
     * @param {Object} parameters - The input parameters for the action.
     * @param {string} parameters.outcome - The outcome type to return.
     * @param {*} parameters.payload - The payload to include in the returned outcome.
     * @returns {Outcome} A new outcome object created from the provided parameters.
     */
    // eslint-disable-next-line class-methods-use-this
    perform(parameters) {
      return Action.createOutcome(parameters.outcome, parameters.payload);
    }
  }

  return ReturnAction;
});

